module.exports = __webpack_public_path__ + "static/media/27OCHA19.0246cf06.jpg";